<template>
  <div>
    <NavBar />
    <div class="container text-center">
      <div class="row justify-content-center">
        <div class="col col-lg-10">
          <div v-if="alertMessage" class="alert alert-success" role="alert">
            <p class="text-center mb-0">
              {{ alertMessage }}
            </p>
          </div>
          <ErrorSummary :error="error" />
          <div class="row">
            <div class="col">
              <div class="card-group">
                <div class="card">
                  <div class="card-body">
                    <h5 class="card-title">Email Interview Link</h5>
                    <p class="card-text">
                      Send a one-time link to the provided email address that can be used to complete the interview.
                    </p>
                  </div>
                  <div class="card-footer">
                    <form ref="form" class="needs-validation" :class="formWasValidated ? 'was-validated' : ''" novalidate @submit.prevent>
                      <div class="input-group form-group mb-0">
                        <input
                          v-model="emailAddress"
                          type="email"
                          class="form-control"
                          placeholder="Email Address"
                          :disabled="loadingMessage || emailSent"
                          required
                          @keyup.enter="emailTest"
                        />
                        <div class="input-group-append">
                          <button type="button" class="btn btn-primary btn-block" :disabled="loadingMessage || emailSent" @click="emailTest">Email</button>
                        </div>
                        <div class="invalid-feedback">
                          Please provide an email address.
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <div class="card">
                  <div class="card-body">
                    <h5 class="card-title">Start Interview Now</h5>
                    <p class="card-text">Start the interview immediately on this device. You will be signed out and the interview will begin.</p>
                  </div>
                  <div class="card-footer">
                    <div class="row justify-content-center">
                      <div class="col col-md-7">
                        <button type="button" class="btn btn-primary btn-block" :disabled="loadingMessage" @click="startTest">Start</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { mapActions } from "vuex";
import NavBar from "@/views/reports/NavBar.vue";
import ErrorSummary from "@/components/ErrorSummary.vue";

export default {
  components: {
    NavBar,
    ErrorSummary,
  },
  props: {
    organizationId: String,
    reportId: String,
    url: String,
  },
  data() {
    return {
      loadingMessage: null,
      formWasValidated: false,
      alertMessage: null,
      error: null,

      emailAddress: null,
      emailSent: false,
    };
  },
  methods: {
    reset() {
      this.loadingMessage = null;
      this.formWasValidated = false;
      this.alertMessage = null;
      this.error = null;
    },
    emailTest() {
      const payload = {
        emailAddress: this.emailAddress,
      };

      // reset
      this.reset();

      // reset form validation
      this.formWasValidated = false;

      // validations
      if (!this.$refs.form.checkValidity()) {
        this.formWasValidated = true;
        return;
      }

      // api
      this.loadingMessage = "Processing...";
      this.$axios
        .post(`/v1/organizations/${this.organizationId}/reports/${this.reportId}/start/email`, payload)
        .then(() => {
          this.alertMessage = "Email successfully sent.";
          this.emailSent = true;
        })
        .catch(err => (this.error = err))
        .finally(() => (this.loadingMessage = null));
    },
    startTest() {
      // reset
      this.reset();

      // logout and redirect
      this.$store.dispatch("signOut").then(() => (window.location = this.url));
    },
  },
};
</script>

<style lang="scss" scoped></style>
